import { defineComponent as _defineComponent } from 'vue'
import { useLayers } from './composables/useLayers';
import store from '@/store';

import type { LayersSettings, LayersFlags, LayersTemplate } from './types';
import type { CanvasEx } from '@/typings/canvas';

import LayersTree from './tree/LayersTree.vue';
import { FindInLayersRef } from './header';
import LayersHeader from './header/LayersHeader.vue';
import FindInLayers from './header/FindInLayers.vue';
import CResizable from '@/components/shared/CResizable.vue';
import LayersHeaderListPreview from '@/components/Layers/header/list-preview/LayersHeaderListPreview.vue';
import { computed, onUnmounted, Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Layers',
  props: {
    settings: null,
    flags: { default: () => ({
            allowSorting: true,
            allowChangingPrintArea: true,
            allowChangingOverlay: true,
            showGroups: true,
            isAbleToGroupOrUnGroup: true,
            enablePageEps: true,
            isAdminTemplateProduct: false,
            startWithCanva: false,
            enableFindInLayers: true,
            isPreMergeFlow: false
        }) },
    canvas: null,
    auxCanvas: null,
    template: null
  },
  emits: ["import-layers", "tree-item-moved", "user-updated"],
  setup(__props: any, { expose, emit }: { emit: ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: 'import-layers', value: any): void;
    (event: 'tree-item-moved'): void;
    (event: 'user-updated'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { settings: LayersSettings, flags: LayersFlags, canvas: CanvasEx | null, auxCanvas?: CanvasEx | null, template?: LayersTemplate };





const flags = computed(() => store.state.storeLayers?.flags);
const isReadonly = computed(() => flags.value?.readonly);
const startWithCanva = computed(() => flags.value?.startWithCanva);
const enableFindInLayers = computed(() => flags.value?.enableFindInLayers);

const {
    setActiveElement,
    singleGroupSelection,
    initGroupSelectionFromPageEps,
    importLayers,
    refreshLayerPanel,
    moveElementForward,
    moveElementBackward,
    bringElementToFront,
    sendElementToBack
} = useLayers(props, emit);

expose({
    setActiveElement,
    singleGroupSelection,
    initGroupSelectionFromPageEps,
    refreshLayerPanel,
    moveElementForward,
    moveElementBackward,
    bringElementToFront,
    sendElementToBack
});

const findInLayersRef: Ref<FindInLayersRef | null> = ref(null);

onUnmounted(() => {
    store.dispatch('storeLayers/clear');
});

const layerTreeItemMove = () => {
    emit('tree-item-moved');
};

const openFindLayers = () => {
    findInLayersRef?.value?.toggle();
};

return { __sfc: true,emit, props, flags, isReadonly, startWithCanva, enableFindInLayers, setActiveElement, singleGroupSelection, initGroupSelectionFromPageEps, importLayers, refreshLayerPanel, moveElementForward, moveElementBackward, bringElementToFront, sendElementToBack, findInLayersRef, layerTreeItemMove, openFindLayers, LayersTree, LayersHeader, FindInLayers, CResizable, LayersHeaderListPreview }
}

})